
import Ajax from '../js/common/ajax';

export default {
	loadSubject(params = {}) {
		return Ajax.get("/accountBook/list", params)
	},
	loadVoucherDetails(params = {}) {
		return Ajax.get("/accountBook/details", params)
	},
	loadVoucherDetailsByDate(params = {}) {
		return Ajax.get("/accountBook/detailsByDate", params)
	},
	loadGeneralLedger(params = {}) {
		return Ajax.get("/accountBook/generalLedger", params)
	},
	loadGeneralLedgerByDate(params = {}) {
		return Ajax.get("/accountBook/generalLedgerByDate", params)
	},
	loadSubjectBalance(params = {}) {
		return Ajax.get("/accountBook/subjectBalance", params)
	},
	loadSubjectBalanceByDate(params = {}) {
		return Ajax.get("/accountBook/subjectBalanceByDate", params)
	},
	loadSubjectSummary(params = {}) {
		return Ajax.get("/accountBook/subjectSummary", params)
	},
	loadSubjectSummaryByDate(params = {}) {
		return Ajax.get("/accountBook/subjectSummaryByDate", params)
	},
	loadAuxiliaryDetails(params = {}) {
		return Ajax.get("/accountBook/auxiliaryDetails", params)
	},
	loadAuxiliaryList(params = {}) {
		return Ajax.get("/accountBook/auxiliaryList", params)
	},
	loadAuxiliaryBalance(params = {}) {
		return Ajax.get("/accountBook/auxiliaryBalance", params)
	},
	loadAuxiliaryListByDate(params = {}) {
		return Ajax.get("/accountBook/auxiliaryListByDate", params)
	},
	loadMultiColDetails(params = {}) {
		return Ajax.get("/accountBook/loadMultiColDetails", params)
	},
}
